module.exports = __webpack_public_path__ + "static/media/6.5e350614.jpg";